import React, { useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  FormControl
} from '@mui/material';

// Pure Local JS Imports
import config from '../../js/config';
import { getBearerString } from "../../js/jwt_token";


type CreateDatasetDialogProps = {
  open: boolean;
  onClose: () => void;
  minioBucketFilePaths: string[]
}

const CreateDatasetDialog = ({ open, onClose, minioBucketFilePaths }: CreateDatasetDialogProps) => {
  const [datasetName, setDatasetName] = useState<string>('');
  const [datasetDescription, setDatasetDescription] = useState<string>('');

  const handleCreate = () => {
    handleCreateDataset();
    setDatasetName('');
    setDatasetDescription('');
    onClose();
  };

  const handleCreateDataset = async () => {
    console.log('Creating dataset:', datasetName, minioBucketFilePaths);

    const request_body = {
      name: datasetName,
      description: datasetDescription,
      bucket_name_file_paths: minioBucketFilePaths
    };

    try {
      const response = await fetch(config.data_platform_api_url + '/datasets/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: getBearerString(),

        },
        body: JSON.stringify(request_body),
      });

      if (response.ok) {
        console.log('Dataset created successfully');
      } else {
        console.error('Failed to create dataset');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}>
      <DialogTitle>Create Dataset</DialogTitle>
      <DialogContent>
        <FormControl fullWidth margin="normal">
          <TextField
            autoFocus
            margin="dense"
            label="Dataset Name"
            fullWidth
            value={datasetName}
            onChange={(e) => setDatasetName(e.target.value)}
          />
        </FormControl>
        <FormControl fullWidth margin="normal">
          <TextField
            autoFocus
            margin="dense"
            label="Dataset Description"
            fullWidth
            value={datasetDescription}
            onChange={(e) => setDatasetDescription(e.target.value)}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleCreate} color="primary">
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateDatasetDialog;